import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import { AddItemPendingItemSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const addReturnItem = {
  name: "addReturnItem" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    previousPendingItemId: z.string().optional(),
    pendingItem: AddItemPendingItemSchema,
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
